import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { ViewportGizmo } from 'three-viewport-gizmo';

export function initializeViewportGizmo(
  camera: THREE.PerspectiveCamera,
  renderer: THREE.WebGLRenderer,
  controls: OrbitControls,
  container: HTMLElement,
): ViewportGizmo {
  // three-viewport-gizmo derives its coordinate convention from Three.js's
  // global default up vector when it is constructed.
  THREE.Object3D.DEFAULT_UP.set(0, 0, 1);
  const gizmo = new ViewportGizmo(camera, renderer, {
    type: 'sphere',
    placement: 'bottom-right',
    size: 80,
    container,
  });
  gizmo.attachControls(controls);
  return gizmo;
}
